"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.someDuplicates = void 0;
/**
 * Checks an array for duplicates.
 * @param comparer  A comparison function that compares two values `a` and `b`. This function returns `-1` when `a` < `b`, `0` when
 *                  `a` == `b`, and `1` when `a` > `b`.
 * @returns `true` if there is at least one pair of duplicate values. `false` if there are no duplicates.
 */
function someDuplicates(source, comparer = defaultComparer) {
    for (let i = 0; i < source.length; i++) {
        for (let n = i + 1; n < source.length; n++) {
            if (comparer(source[i], source[n]) === 0) {
                return true;
            }
        }
    }
    return false;
}
exports.someDuplicates = someDuplicates;
function defaultComparer(a, b) {
    return a === b ? 0 : a < b ? -1 : 1;
}
//# sourceMappingURL=#some-duplicates.js.map